/** PURE_IMPORTS_START .._operators_single PURE_IMPORTS_END */
import { single as higherOrder } from '../operators/single';
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
export function single(predicate) {
    return higherOrder(predicate)(this);
}
//# sourceMappingURL=single.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/single.js
// module id = 855
// module chunks = 0